import { render, staticRenderFns } from "./ClientDetailHeader.vue?vue&type=template&id=938d24c6&scoped=true"
import script from "./ClientDetailHeader.vue?vue&type=script&lang=js"
export * from "./ClientDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./ClientDetailHeader.vue?vue&type=style&index=0&id=938d24c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938d24c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
